module.exports = __webpack_public_path__ + "img/green_009.5e0867ce.png";